import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "Объявления", -1)

import { usePermissions } from "@/use/usePermissions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";

import UiIconBtn from "@/components/ui/UiIconBtn.vue";

import AppSidebar from "@/components/AppSidebar.vue";
import AppTabbar from "@/components/AppTabbar.vue";
import NewsList from "@/features/news/components/NewsList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPage',
  setup(__props) {

const { isAllow, getDenyType } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Объявления"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(isAllow)('news'))
        ? (_openBlock(), _createBlock(NewsList, { key: 0 }))
        : (_unref(getDenyType)('news') === 'unsupported')
          ? (_openBlock(), _createBlock(UiPlaceholder, {
              key: 1,
              icon: "Newspaper",
              title: "Модуль «Объявления и голосования» недоступен",
              description: "К сожалению, модуль «Объявления и голосования» не подключен к вашей школе."
            }))
          : (_unref(getDenyType)('news') === 'subscription')
            ? (_openBlock(), _createBlock(UiPlaceholder, {
                key: 2,
                icon: "Newspaper",
                title: "Модуль «Объявления и голосования» доступны по подписке",
                description: "Модуль «Объявления и голосования» будет доступен после оформления расширенной подписки."
              }))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})